import { render, staticRenderFns } from "./OSheet.vue?vue&type=template&id=f872b74c&scoped=true"
import script from "./OSheet.vue?vue&type=script&lang=ts"
export * from "./OSheet.vue?vue&type=script&lang=ts"
import style0 from "./OSheet.vue?vue&type=style&index=0&id=f872b74c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f872b74c",
  null
  
)

export default component.exports